<footer class="footer text-secondary footer-dark">
  <div class="container-fluid">
    <span class="footer-text">&copy; 2025 Runtech Systems. All Rights Reserved</span>
    <span class="footer-version">v1.1</span>
  </div>
</footer>
